// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './Message.scss';
import { CSSTransitionGroup  } from 'react-transition-group';

@inject('messageStore')
@observer class Message extends Component<any, any> {
	render() {
		return (
			<CSSTransitionGroup  
				transitionName="animate-message"
				transitionEnterTimeout={300}
				transitionLeaveTimeout={300}>
				{ this.props.messageStore.type !== '' ?
					<div className={"message " + this.props.messageStore.type}>
						<span className="inner-message">{this.props.messageStore.message}</span>
					</div>
				:
				null
				}
			</CSSTransitionGroup>
		)
	}
}

export default Message;

